/**
 * Performance instrumentation for cascade timing (Phase 0.4).
 *
 * Usage:
 *   import { perfMark, perfMeasure, dumpCascadeTimings } from '@utils/performance'
 *   perfMark('auth-start')
 *   // ... later ...
 *   perfMark('auth-end')
 *   perfMeasure('auth-flow', 'auth-start', 'auth-end')
 */

const PREFIX = 'berlitz:'

export function perfMark(name: string): void {
  try {
    performance.mark(`${PREFIX}${name}`)
  } catch {
    // SSR or unsupported browser — silently skip
  }
}

export function perfMeasure(label: string, startMark: string, endMark: string): PerformanceMeasure | null {
  try {
    return performance.measure(`${PREFIX}${label}`, `${PREFIX}${startMark}`, `${PREFIX}${endMark}`)
  } catch {
    return null
  }
}

/** Collect all berlitz: measures into a plain object for logging / Datadog */
export function dumpCascadeTimings(): Record<string, number> {
  try {
    const entries = performance.getEntriesByType('measure') as PerformanceMeasure[]
    const timings: Record<string, number> = {}
    for (const e of entries) {
      if (e.name.startsWith(PREFIX)) {
        timings[e.name.replace(PREFIX, '')] = Math.round(e.duration)
      }
    }
    return timings
  } catch {
    return {}
  }
}
